/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/type-annotation-spacing */
/* eslint-disable no-underscore-dangle */
/* eslint-disable eqeqeq */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/prefer-for-of */
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { Router } from "@angular/router";
import { ActionSheetController, ToastController } from "@ionic/angular";
import { DomSanitizer } from "@angular/platform-browser";
import { FormBuilder, FormGroup, NgForm } from "@angular/forms";
import { HttpClient } from "@angular/common/http";
// import { DocumentManuallyRejectedComponent } from "./document-manually-rejected/document-manually-rejected.component";
import { ProgressSpinnerComponent } from "src/app/progress-spinner/progress-spinner.component";
import { AuditTrailService } from "../audit-trail.service";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ViewProfileDocumentComponent } from "./view-profile-document/view-profile-document.component";

@Component({
  selector: "app-profile-details",
  templateUrl: "./profile-details.component.html",
  styleUrls: ["./profile-details.component.scss"],
})
export class ProfileDetailsComponent implements OnInit {
  //   profileDetails: any[] = [];
  //   documents: any[] = [];
  //   areQuestionsNotAnswered: boolean = false;
  //   regId: string = "";
  //   originalResponse: any[] = [];
  //   isEsignDisabled: boolean = true;
  //   downloadEsignDisabled: boolean = true;
  //   applyNowBtnDisabled: boolean = true;

  //   constructor(private auditTrailService: AuditTrailService, private _snackBar: MatSnackBar) {}

  //   ngOnInit() {}

  //   async getProfileDetails() {
  //     this.originalResponse = [];
  //     this.documents = [];
  //     await this.auditTrailService.getProfileDetailsReport(this.regId).subscribe((response: any) => {
  //       if (response != null && !response.error) {
  //         setTimeout(() => {
  //           // this.profileDetails = response.pop();

  //           if (response.length > 0) {
  //             localStorage.setItem("editRecords", JSON.stringify(response));
  //             let tempArray = JSON.parse(localStorage.getItem("editRecords"));
  //             let employeeFlag = false;

  //             for (let i = 0; i < tempArray.length; i++) {
  //               this.originalResponse.push({
  //                 qsQuestion: response[i]["qsQuestion"]["en"],
  //                 ans_status: response[i]["ans_status"],
  //                 qs_ans_status: response[i]["qs_ans_status"],
  //                 qs_ans: response[i]["qs_ans"],
  //                 qsCode: response[i]["qsCode"],
  //               });
  //             }
  //             for (let i = 0; i < response.length; i++) {
  //               if (response[i]["qsCode"] == "Q_PAN" && response[i]["qs_ans_status"] == "Rejected-Duplicate") {
  //                 response[i]["qs_ans_status"] = "MHADA Winner with Possession";
  //               }

  //               if (response[i]["qsCode"] == "Q_CASTE" && response[i]["qs_ans"] == "OPEN") {
  //                 response[i + 1]["qs_ans_status"] = "Not Applicable";
  //               }

  //               if (response[i]["qsCode"] == "Q_DOMICILE" && response[i]["qs_ans_status"] == "Not-Verified") {
  //                 response[i]["qs_ans_status"] = "Verification in Progress";
  //               }

  //               if (response[i]["qsCode"] == "Q_ITR" && response[i]["qs_ans_status"] == "Not-Verified") {
  //                 response[i]["qs_ans_status"] = "Verification in Progress";
  //               } else if (response[i]["qsCode"] == "Q_ITR_SPOUSE" && response[i]["qs_ans_status"] == "Not-Verified") {
  //                 response[i]["qs_ans_status"] = "Verification in Progress";
  //               }

  //               if (response[i]["qsCode"] == "Q_MARITAL" && response[i]["qs_ans"] != "Married") {
  //                 // i = 6
  //                 if (response[i + 3]["qsCode"] == "Q_WORK_STATUS" && response[i + 3]["qs_ans"] == "None") {
  //                   response[i + 1]["qs_ans_status"] = "Not Applicable"; // i = 7
  //                   response[i + 2]["qs_ans_status"] = "Not Applicable"; // i = 8
  //                   response[i + 4]["qs_ans_status"] = "Not Applicable"; // i = 8
  //                   response[i + 5]["qs_ans_status"] = "Not Applicable"; // i = 11
  //                   response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
  //                 } else {
  //                   response[i + 1]["qs_ans_status"] = "Not Applicable"; // i = 7
  //                   response[i + 2]["qs_ans_status"] = "Not Applicable"; // i = 8
  //                   response[i + 5]["qs_ans_status"] = "Not Applicable"; // i = 11
  //                   response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
  //                 }
  //               } else if (response[i]["qsCode"] == "Q_MARITAL" && response[i]["qs_ans"] == "Married") {
  //                 // i= 6
  //                 if (
  //                   response[i + 3]["qsCode"] == "Q_WORK_STATUS" &&
  //                   response[i + 3]["qs_ans_status"] != "Not Answered"
  //                 ) {
  //                   // i = 9
  //                   if (response[i + 3]["qs_ans"] == "Both") {
  //                     if (
  //                       response[i + 4]["qs_ans_status"] == "Verified" ||
  //                       response[i + 4]["qs_ans_status"] == "Rejected" ||
  //                       response[i + 5]["qs_ans_status"] == "Verified" ||
  //                       response[i + 5]["qs_ans_status"] == "Rejected"
  //                     ) {
  //                       response[i + 6]["qs_ans_status"] = "Not Applicable";
  //                     } else if (
  //                       response[i + 6]["qs_ans_status"] == "Verified" ||
  //                       response[i + 6]["qs_ans_status"] == "Rejected" ||
  //                       response[i + 6]["qs_ans_status"] == "Not-Verified"
  //                     ) {
  //                       response[i + 4]["qs_ans_status"] = "Not Applicable";
  //                       response[i + 5]["qs_ans_status"] = "Not Applicable";
  //                     }
  //                   } else if (response[i + 3]["qs_ans"] == "Self") {
  //                     // i = 9
  //                     response[i + 5]["qs_ans_status"] = "Not Applicable"; // i= 11
  //                     response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
  //                   } else if (response[i + 3]["qs_ans"] == "Spouse") {
  //                     // i = 9
  //                     response[i + 6]["qs_ans_status"] = "Not Applicable";
  //                     response[i + 4]["qs_ans_status"] = "Not Applicable";
  //                   } else if (response[i + 3]["qs_ans"] == "None") {
  //                     response[i + 5]["qs_ans_status"] = "Not Applicable";
  //                     response[i + 6]["qs_ans_status"] = "Not Applicable";
  //                     response[i + 4]["qs_ans_status"] = "Not Applicable"; // i = 10
  //                   }
  //                 }
  //               }

  //               if (employeeFlag == false) {
  //                 if (response[i + 2] != undefined) {
  //                   if (
  //                     response[i]["qsCode"] == "Q_CENTRAL" &&
  //                     (response[i]["qs_ans_status"] == "Uploaded" ||
  //                       response[i]["qs_ans_status"] == "Not-Verified" ||
  //                       response[i]["qs_ans_status"] == "Verified")
  //                   ) {
  //                     response[i + 1]["qs_ans_status"] = "Not Applicable";
  //                     response[i + 2]["qs_ans_status"] = "Not Applicable";
  //                     response[6]["qs_ans_status"] = "Not Applicable";
  //                     employeeFlag = true;
  //                   } else if (
  //                     response[i + 1]["qsCode"] == "Q_STATE" &&
  //                     (response[i + 1]["qs_ans_status"] == "Uploaded" ||
  //                       response[i + 1]["qs_ans_status"] == "Not-Verified" ||
  //                       response[i + 1]["qs_ans_status"] == "Verified")
  //                   ) {
  //                     response[i]["qs_ans_status"] = "Not Applicable";
  //                     response[i + 2]["qs_ans_status"] = "Not Applicable";
  //                     employeeFlag = true;
  //                   } else if (
  //                     response[i + 2]["qsCode"] == "Q_MHADA" &&
  //                     (response[i + 2]["qs_ans_status"] == "Verified" || response[i + 2]["qs_ans_status"] == "Rejected")
  //                   ) {
  //                     response[i]["qs_ans_status"] = "Not Applicable";
  //                     response[i + 1]["qs_ans_status"] = "Not Applicable";
  //                     employeeFlag = true;
  //                   }
  //                 }
  //               }

  //               if (
  //                 (response[i]["qs_ans"] == "No" && response[i]["qs_ans_status"] == "Answered") ||
  //                 (response[i]["qs_ans"] == "None" && response[i]["qs_ans_status"] == "Answered") ||
  //                 (response[i]["qs_ans"] == "None of the above" && response[i]["qs_ans_status"] == "Answered")
  //               ) {
  //                 if (response[i]["qsCode"] == "Q_CAST_VALID") {
  //                   response[i]["qs_ans_status"] = "Allowed with Condition";
  //                 } else {
  //                   response[i]["qs_ans_status"] = "Not Applicable";
  //                   response[i]["qs_ans"] = "";
  //                 }
  //               } else if (response[i]["qs_ans_status"] == "Not-Verified") {
  //                 response[i]["qs_ans_status"] = "Verification in Progress";
  //               }

  //               this.documents.push({
  //                 qsQuestion: response[i]["qsQuestion"]["en"],
  //                 ans_status: response[i]["ans_status"],
  //                 qs_ans_status: response[i]["qs_ans_status"],
  //                 qs_ans: response[i]["qs_ans"],
  //               });
  //             }

  //             for (let i = 0; i < this.documents.length; i++) {
  //               if (
  //                 this.documents[i]["qs_ans_status"] != null &&
  //                 this.documents[i]["qs_ans_status"].toLowerCase().includes("rejected")
  //               ) {
  //                 // this.manualRejectedQuestions.push(this.documents[i]);
  //                 this.applyNowBtnDisabled = true;
  //                 this.downloadEsignDisabled = true;
  //                 this.isEsignDisabled = true;
  //                 this.areQuestionsNotAnswered = true;
  //               } else if (
  //                 this.documents[i]["qs_ans_status"] == null ||
  //                 this.documents[i]["qs_ans_status"].startsWith("Rejected") ||
  //                 this.documents[i]["qs_ans_status"] == "Not Answered" ||
  //                 this.documents[i]["qs_ans_status"] == "Pending for Moderator Check" ||
  //                 this.documents[i]["qs_ans_status"] == "Verification in Progress" ||
  //                 this.documents[i]["qs_ans_status"] == "MHADA Winner with Possession"
  //               ) {
  //                 this.applyNowBtnDisabled = true;
  //                 this.downloadEsignDisabled = true;
  //                 this.isEsignDisabled = true;
  //                 this.areQuestionsNotAnswered = true;
  //               }
  //             }
  //             setTimeout(() => {
  //               if (this.profileDetails[0]["affidavitStatus"] == "" && this.areQuestionsNotAnswered == false) {
  //                 this.applyNowBtnDisabled = true;
  //                 this.downloadEsignDisabled = true;
  //                 this.isEsignDisabled = false;
  //                 localStorage.removeItem("eSign");
  //               } else if (
  //                 this.profileDetails[0]["affidavitStatus"].toLowerCase() == "pending" &&
  //                 this.areQuestionsNotAnswered == false
  //               ) {
  //                 // localStorage.setItem("eSign", "true");
  //                 if (localStorage.getItem("eSign") == "true") {
  //                   // this.getSignedPdf();
  //                 } else {
  //                   localStorage.removeItem("eSign");
  //                   this.applyNowBtnDisabled = true;
  //                   this.downloadEsignDisabled = true;
  //                   this.isEsignDisabled = false;
  //                 }
  //               } else if (
  //                 this.profileDetails[0]["affidavitStatus"].toLowerCase() == "verified" &&
  //                 this.areQuestionsNotAnswered == false
  //               ) {
  //                 this.applyNowBtnDisabled = false;
  //                 this.downloadEsignDisabled = false;
  //                 this.isEsignDisabled = true;
  //               }
  //             }, 1000);
  //           } else {
  //             this.warningToast();
  //           }
  //         }, 2000);
  //       } else {
  //         this.errorToast();
  //       }
  //     });
  //   }

  //   async warningToast() {
  //     await this._snackBar.open("No data available for the entered regId.", "Close", {
  //       horizontalPosition: "right",
  //       verticalPosition: "top",
  //       panelClass: "warning-toast",
  //       duration: 3 * 1000,
  //     });
  //   }

  //   async errorToast() {
  //     await this._snackBar.open("Oops, something went wrong, please try after sometime.", "Close", {
  //       horizontalPosition: "right",
  //       verticalPosition: "top",
  //       panelClass: "error-toast",
  //       duration: 3 * 1000,
  //     });
  //   }
  // }

  @ViewChild("addform") addform: NgForm;
  contactsForm: FormGroup;

  panNo = "";
  aadharNo = "";
  name = "";
  address = "";
  currentAddress = "";
  aliasName = "";
  mobileNo = "";
  otherName1 = "";
  otherName2 = "";
  otherName3 = "";
  photo: any = null;
  progressSpinnerDialog: any = null;
  documents: any[] = [];
  refresherEvent: any = null;
  verifiedStatus: any[] = [];
  isEsignDisabled = true;
  applyNowBtnDisabled = true;
  regId = localStorage.getItem("regId");
  obj: any = null;
  dob: any = "";
  activeLang: string = "en";
  viewEnMr: string = "View";
  cancelEnMr: string = "Cancel";
  editEnMr: string = "Edit";
  ipAddress: any = null;
  pdfSrc: any = "";
  documentName: string = "";
  downloadEsignDisabled: boolean = true;
  areQuestionsNotAnswered: boolean = false;
  manualRejectedQuestions: any[] = [];
  profileDetails: any[] = [];
  searchedPanNo: string = "";

  constructor(
    public actionSheetController: ActionSheetController,
    private dialog: MatDialog,
    private _snackBar: MatSnackBar,
    private router: Router,
    private _fb: FormBuilder,
    public toastController: ToastController,
    private auditTrailService: AuditTrailService,
    private http: HttpClient,
    private domSanitizer: DomSanitizer
  ) {
    this.contactsForm = this._fb.group({
      Parameter1: "",
      Parameter2: "",
      Parameter3: "",
    });
  }

  async ngOnInit() {
    this.platform = localStorage.getItem("platform");
  }

  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }

  // async refreshPage(event: any) {
  //   this.refresherEvent = event;
  //   this.getDocuments();
  // }
  async refreshPage() {
    // this.getDocuments();
    window.location.reload();
  }

  async getDocuments() {
    this.manualRejectedQuestions = [];
    this.documents = [];
    this.verifiedStatus = [];
    this.displayProgressSpinner();
    await this.auditTrailService.getProfileDetails(this.searchedPanNo).subscribe((response: any) => {
      // const response: any = await profile;
      this.progressSpinnerDialog.close();
      if (response != null && !response.error) {
        if (response.length > 0) {
          this.profileDetails = response.pop();
          this.mobileNo = this.profileDetails[0]["mobileNo"];
          this.address = this.profileDetails[0]["address"];
          this.currentAddress = this.profileDetails[0]["currentAddress"];
          this.aliasName = this.profileDetails[0]["alisName"];
          this.photo = this.domSanitizer.bypassSecurityTrustResourceUrl(
            "data:image/jpg;base64," + this.profileDetails[0]["photo"]
          );
          this.panNo = this.profileDetails[0]["panNo"];
          this.name = this.profileDetails[0]["name"];
          this.dob = this.profileDetails[0]["dob"];

          if(this.profileDetails[0]["otherName1"]){
            this.otherName1 = this.profileDetails[0]["otherName1"];
          }
          if(this.profileDetails[0]["otherName2"]){
            this.otherName2 = this.profileDetails[0]["otherName2"];
          }
          if(this.profileDetails[0]["otherName3"]){
            this.otherName3 = this.profileDetails[0]["otherName3"];
          }

          if (response.length > 0) {
            localStorage.setItem("editRecords", JSON.stringify(response));
            let employeeFlag = false;
            // response.sort((a, b) => a.pkQsid - b.pkQsid);
            // console.log(response);
            for (let i = 0; i < response.length; i++) {
              // if (
              //   response[i]["qsCode"] == "Q_FREEDOM" &&
              //   (response[i]["qs_ans_status"] == "Uploaded" ||
              //     response[i]["qs_ans_status"] == "Not-Verified" ||
              //     response[i]["qs_ans_status"] == "Verified" ||
              //     response[i]["qs_ans_status"] == "Answered")
              // ) {
              //   response[i + 1]["qs_ans_status"] = "Not Applicable";
              // } else if (
              //   response[i]["qsCode"] == "Q_FREEDOM" &&
              //   (response[i + 1]["qs_ans_status"] == "Uploaded" ||
              //     response[i + 1]["qs_ans_status"] == "Not-Verified" ||
              //     response[i + 1]["qs_ans_status"] == "Verified")
              // ) {
              //   response[i]["qs_ans_status"] = "Not Applicable";
              // }
              if (response[i]["qsCode"] == "Q_PAN" && response[i]["qs_ans_status"] == "Rejected-Duplicate") {
                response[i]["qs_ans_status"] = "MHADA Winner with Possession";
              }
              if (response[i]["qsCode"] == "Q_CASTE" && response[i]["qs_ans"] == "OPEN") {
                response[i + 1]["qs_ans_status"] = "Not Applicable";
              }
              if (response[i]["qsCode"] == "Q_DOMICILE" && response[i]["qs_ans_status"] == "Not-Verified") {
                response[i]["qs_ans_status"] = "Verification in Progress";
              }
              if (response[i]["qsCode"] == "Q_ITR" && response[i]["qs_ans_status"] == "Not-Verified") {
                response[i]["qs_ans_status"] = "Verification in Progress";
              } else if (response[i]["qsCode"] == "Q_ITR_SPOUSE" && response[i]["qs_ans_status"] == "Not-Verified") {
                response[i]["qs_ans_status"] = "Verification in Progress";
              }
              // if (response[i]["qsCode"] == "Q_MARITAL" && response[i]["qs_ans"] != "Married") {
              //   response[7]["qs_ans_status"] = "Not Applicable";
              //   response[8]["qs_ans_status"] = "Not Applicable";
              //   response[11]["qs_ans_status"] = "Not Applicable";
              //   response[12]["qs_ans_status"] = "Not Applicable";
              // } else if (response[i]["qsCode"] == "Q_MARITAL" && response[i]["qs_ans"] == "Married") {
              //   if (response[9]["qsCode"] == "Q_WORK_STATUS" && response[9]["qs_ans_status"] != "Not Answered") {
              //     if (response[9]["qs_ans"] == "Both") {
              //     } else if (response[9]["qs_ans"] == "Self") {
              //       response[11]["qs_ans_status"] = "Not Applicable";
              //       response[12]["qs_ans_status"] = "Not Applicable";
              //     } else if (response[9]["qs_ans"] == "Spouse") {
              //       response[12]["qs_ans_status"] = "Not Applicable";
              //       response[10]["qs_ans_status"] = "Not Applicable";
              //     } else if (response[9]["qs_ans"] == "None") {
              //       response[11]["qs_ans_status"] = "Not Applicable";
              //       response[12]["qs_ans_status"] = "Not Applicable";
              //       response[10]["qs_ans_status"] = "Not Applicable";
              //     }
              //   }
              // }
              if (response[i]["qsCode"] == "Q_MARITAL" && response[i]["qs_ans"] != "Married") {
                // i = 6
                if (response[i + 3]["qsCode"] == "Q_WORK_STATUS" && response[i + 3]["qs_ans"] == "None") {
                  response[i + 1]["qs_ans_status"] = "Not Applicable"; // i = 7
                  response[i + 2]["qs_ans_status"] = "Not Applicable"; // i = 8
                  response[i + 4]["qs_ans_status"] = "Not Applicable"; // i = 8
                  response[i + 5]["qs_ans_status"] = "Not Applicable"; // i = 11
                  response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
                } else {
                  response[i + 1]["qs_ans_status"] = "Not Applicable"; // i = 7
                  response[i + 2]["qs_ans_status"] = "Not Applicable"; // i = 8
                  response[i + 5]["qs_ans_status"] = "Not Applicable"; // i = 11
                  response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
                }
                // response[i + 1]["qs_ans_status"] = "Not Applicable"; // i = 7
                // response[i + 2]["qs_ans_status"] = "Not Applicable"; // i = 8
                // response[i + 5]["qs_ans_status"] = "Not Applicable"; // i = 11
                // response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
              } else if (response[i]["qsCode"] == "Q_MARITAL" && response[i]["qs_ans"] == "Married") {
                // i= 6
                if (
                  response[i + 3]["qsCode"] == "Q_WORK_STATUS" &&
                  response[i + 3]["qs_ans_status"] != "Not Answered"
                ) {
                  // i = 9
                  if (response[i + 3]["qs_ans"] == "Both") {
                    if (
                      response[i + 4]["qs_ans_status"] == "Verified" ||
                      response[i + 4]["qs_ans_status"] == "Rejected" ||
                      response[i + 5]["qs_ans_status"] == "Verified" ||
                      response[i + 5]["qs_ans_status"] == "Rejected"
                    ) {
                      response[i + 6]["qs_ans_status"] = "Not Applicable";
                    } else if (
                      response[i + 6]["qs_ans_status"] == "Verified" ||
                      response[i + 6]["qs_ans_status"] == "Rejected" ||
                      response[i + 6]["qs_ans_status"] == "Not-Verified"
                    ) {
                      response[i + 4]["qs_ans_status"] = "Not Applicable";
                      response[i + 5]["qs_ans_status"] = "Not Applicable";
                    }
                  } else if (response[i + 3]["qs_ans"] == "Self") {
                    // i = 9
                    response[i + 5]["qs_ans_status"] = "Not Applicable"; // i= 11
                    response[i + 6]["qs_ans_status"] = "Not Applicable"; // i = 12
                  } else if (response[i + 3]["qs_ans"] == "Spouse") {
                    // i = 9
                    response[i + 6]["qs_ans_status"] = "Not Applicable";
                    response[i + 4]["qs_ans_status"] = "Not Applicable";
                  } else if (response[i + 3]["qs_ans"] == "None") {
                    response[i + 5]["qs_ans_status"] = "Not Applicable";
                    response[i + 6]["qs_ans_status"] = "Not Applicable";
                    response[i + 4]["qs_ans_status"] = "Not Applicable"; // i = 10
                  }
                }
              }
              // if (response[19]["qsCode"] == "Q_CENTRAL" && response[19]["qs_ans_status"] == "Uploaded") {
              //   response[20]["qs_ans_status"] = "Not Applicable";
              //   response[21]["qs_ans_status"] = "Not Applicable";
              // } else if (response[20]["qsCode"] == "Q_STATE" && response[20]["qs_ans_status"] == "Uploaded") {
              //   response[20]["qs_ans_status"] = "Not Applicable";
              //   response[21]["qs_ans_status"] = "Not Applicable";
              // } else if (
              //   response[21]["qsCode"] == "Q_MHADA" &&
              //   (response[21]["qs_ans_status"] == "Verified" || response[21]["qs_ans_status"] == "Rejected")
              // ) {
              //   response[19]["qs_ans_status"] = "Not Applicable";
              //   response[20]["qs_ans_status"] = "Not Applicable";
              // }
              if (employeeFlag == false) {
                if (response[i + 2] != undefined) {
                  if (
                    response[i]["qsCode"] == "Q_CENTRAL" &&
                    (response[i]["qs_ans_status"] == "Uploaded" ||
                      response[i]["qs_ans_status"] == "Not-Verified" ||
                      response[i]["qs_ans_status"] == "Verified")
                  ) {
                    response[i + 1]["qs_ans_status"] = "Not Applicable";
                    response[i + 2]["qs_ans_status"] = "Not Applicable";
                    response[6]["qs_ans_status"] = "Not Applicable";
                    employeeFlag = true;
                  } else if (
                    response[i + 1]["qsCode"] == "Q_STATE" &&
                    (response[i + 1]["qs_ans_status"] == "Uploaded" ||
                      response[i + 1]["qs_ans_status"] == "Not-Verified" ||
                      response[i + 1]["qs_ans_status"] == "Verified")
                  ) {
                    response[i]["qs_ans_status"] = "Not Applicable";
                    response[i + 2]["qs_ans_status"] = "Not Applicable";
                    employeeFlag = true;
                  } else if (
                    response[i + 2]["qsCode"] == "Q_MHADA" &&
                    (response[i + 2]["qs_ans_status"] == "Verified" || response[i + 2]["qs_ans_status"] == "Rejected")
                  ) {
                    response[i]["qs_ans_status"] = "Not Applicable";
                    response[i + 1]["qs_ans_status"] = "Not Applicable";
                    employeeFlag = true;
                  }
                }
              }
              if (
                (response[i]["qs_ans"] == "No" && response[i]["qs_ans_status"] == "Answered") ||
                (response[i]["qs_ans"] == "None" && response[i]["qs_ans_status"] == "Answered") ||
                (response[i]["qs_ans"] == "None of the above" && response[i]["qs_ans_status"] == "Answered")
              ) {
                if (response[i]["qsCode"] == "Q_CAST_VALID") {
                  response[i]["qs_ans_status"] = "Allowed with Condition";
                } else {
                  response[i]["qs_ans_status"] = "Not Applicable";
                  response[i]["qs_ans"] = "";
                }
              } else if (response[i]["qs_ans_status"] == "Not-Verified") {
                // response[i]["qs_ans_status"] = "Pending for Moderator Check";
                response[i]["qs_ans_status"] = "Verification in Progress";
                // response[i]["qs_ans"] = "";
              }
              // if (response[i]["qs_ans_status"] == "Verified" || response[i]["qs_ans_status"] == "N A") {
              //   this.verifiedStatus.push(response);
              // }
              if (response[i]["qs_ans"] != null) {
                if (response[i]["qs_ans"].includes("###")) {
                  if (response[i]["qsCode"] == "Q_ADDRESS") {
                    let splitData = response[i]["qs_ans"].split("###");
                    response[i]["qs_ans"] = splitData[0];
                    if (splitData[1] == "51") {
                      this.documentName = "No / Electricity Bill - MSEB";
                    } else if (splitData[1] == "52") {
                      this.documentName = "No / Electricity Bill - BEST";
                    } else if (splitData[1] == "53") {
                      this.documentName = "No / Electricity Bill - TORRENT";
                    } else if (splitData[1] == "53") {
                      this.documentName = "No / Electricity Bill - TORRENT";
                    } else if (splitData[1] == "54") {
                      this.documentName = "No / Electricity Bill - ADANI";
                    } else if (splitData[1] == "55") {
                      this.documentName = "No / Driving License";
                    } else if (splitData[1] == "56") {
                      this.documentName = "No / Gas Bill";
                    } else if (splitData[1] == "57") {
                      this.documentName = "No / Rent Agreement (Index-2)";
                    } else if (splitData[1] == "1") {
                      this.documentName = "Yes / Same as Aadhar";
                    } else {
                      this.documentName = splitData[1];
                    }
                  } else {
                    response[i]["qs_ans"] = response[i]["qs_ans"].split("###")[0];
                  }
                }
              }
              if (response[i]["qsCode"] != "Q_CONSENT") {
                this.documents.push(response[i]);
              }
            }
            for (let i = 0; i < this.documents.length; i++) {
              // if (this.documents[i]["qs_ans_status"] == "Rejected-Manual") {
              if (this.documents[i]["qs_ans_status"] != null) {
                if (this.documents[i]["qs_ans_status"].toLowerCase().includes("rejected") == true) {
                  this.manualRejectedQuestions.push(this.documents[i]);
                  this.applyNowBtnDisabled = true;
                  this.downloadEsignDisabled = true;
                  this.isEsignDisabled = true;
                  this.areQuestionsNotAnswered = true;
                } else if (
                  this.documents[i]["qs_ans_status"].startsWith("Rejected") ||
                  this.documents[i]["qs_ans_status"] == "Not Answered" ||
                  this.documents[i]["qs_ans_status"] == "Pending for Moderator Check" ||
                  this.documents[i]["qs_ans_status"] == "Verification in Progress" ||
                  this.documents[i]["qs_ans_status"] == "MHADA Winner with Possession"
                ) {
                  this.applyNowBtnDisabled = true;
                  this.downloadEsignDisabled = true;
                  this.isEsignDisabled = true;
                  this.areQuestionsNotAnswered = true;
                }
              } else {
                this.applyNowBtnDisabled = true;
                this.downloadEsignDisabled = true;
                this.isEsignDisabled = true;
                this.areQuestionsNotAnswered = true;
              }
            }
            if (this.manualRejectedQuestions.length > 0) {
              this.casteValidityRejected(this.manualRejectedQuestions);
            }
            setTimeout(() => {
              if (this.profileDetails[0]["affidavitStatus"] == "" && this.areQuestionsNotAnswered == false) {
                this.applyNowBtnDisabled = true;
                this.downloadEsignDisabled = true;
                this.isEsignDisabled = false;
                localStorage.removeItem("eSign");
              } else if (
                this.profileDetails[0]["affidavitStatus"].toLowerCase() == "pending" &&
                this.areQuestionsNotAnswered == false
              ) {
                // localStorage.setItem("eSign", "true");
                if (localStorage.getItem("eSign") == "true") {
                  this.getSignedPdf();
                } else {
                  localStorage.removeItem("eSign");
                  this.applyNowBtnDisabled = true;
                  this.downloadEsignDisabled = true;
                  this.isEsignDisabled = false;
                }
              } else if (
                this.profileDetails[0]["affidavitStatus"].toLowerCase() == "verified" &&
                this.areQuestionsNotAnswered == false
              ) {
                this.applyNowBtnDisabled = false;
                this.downloadEsignDisabled = false;
                this.isEsignDisabled = true;
              }
            }, 1000);
          } else {
            this.warningToast();
          }
        } else {
          this.applyNowBtnDisabled = true;
          this.downloadEsignDisabled = true;
          this.isEsignDisabled = true;
          this.areQuestionsNotAnswered = true;
          this.documents = [];
        }
      } else {
        this.errorToast();
      }
    });
  }

  async presentActionSheet(document: any) {
    let canCasteValidityBeEdited = false;
    if (document.qsCode == "Q_CAST_VALID") {
      if (this.documents[15]["qsCode"] == "Q_CASTE" && this.documents[15]["qs_ans"] != "OPEN") {
        canCasteValidityBeEdited = true;
      }
    }
    let actionSheetOptions: any[] = [];
    if (
      document.pkQsid == "4" ||
      document.pkQsid == "6" ||
      document.pkQsid == "9" ||
      document.pkQsid == "12" ||
      document.pkQsid == "14" ||
      document.pkQsid == "17" ||
      document.pkQsid == "18" ||
      document.pkQsid == "19" ||
      document.pkQsid == "20" ||
      document.pkQsid == "21" ||
      document.pkQsid == "22" ||
      document.pkQsid == "23" ||
      document.pkQsid == "25" ||
      document.pkQsid == "26" ||
      document.pkQsid == "31" ||
      canCasteValidityBeEdited ||
      (document.qs_ans_status != "Not Applicable" &&
        (document.pkQsid == "10" ||
          document.pkQsid == "11" ||
          document.pkQsid == "28" ||
          document.pkQsid == "29" ||
          document.pkQsid == "30"))
    ) {
      actionSheetOptions = [
        {
          cssClass: "first-button",
          text: this.viewEnMr,
          icon: "eye",
          data: 10,
          handler: () => {
            this.viewDocument(document);
          },
        },
        {
          text: this.editEnMr,
          icon: "create",
          data: "Data value",
          handler: () => {
            this.editRecord(document);
          },
        },
        {
          cssClass: "last-button",
          text: this.cancelEnMr,
          icon: "close",
          role: "cancel",
          handler: () => {
            // console.log('Cancel clicked');
          },
        },
      ];
    } else {
      actionSheetOptions = [
        {
          cssClass: "first-button",
          text: this.viewEnMr,
          icon: "eye",
          data: 10,
          handler: () => {
            this.viewDocument(document);
          },
        },
        // {
        //   text: this.editEnMr,
        //   icon: "create",
        //   data: "Data value",
        //   handler: () => {
        //     this.editRecord(document);
        //   },
        // },
        {
          cssClass: "last-button",
          text: this.cancelEnMr,
          icon: "close",
          role: "cancel",
          handler: () => {
            // console.log('Cancel clicked');
          },
        },
      ];
    }
    let status = document.qs_ans_status != null ? document.qs_ans_status : "-";
    const actionSheet = await this.actionSheetController.create({
      header: document.qsProfileDescription[this.activeLang] + " - ( " + status + " )",
      cssClass: "my-custom-class",
      buttons: actionSheetOptions,
    });
    await actionSheet.present();

    const { role, data } = await actionSheet.onDidDismiss();
    // console.log('onDidDismiss resolved with role and data', role, data);
  }

  async viewDocument(document) {
    console.log(document);

    if (document.qs_doc_document != "" && document.qs_doc_document != null && document.qs_doc_document != "-") {
      const progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
        disableClose: true,
        panelClass: "progressSpinner",
      });
      let imageBackUrl = null;
      let image = document.qs_doc_document.split(",");
      console.log(image);

      if (image[1] != undefined) {
        await this.auditTrailService.downloadFile(image[1].split("/").pop()).subscribe((response: any) => {
          progressSpinnerDialog.close();
          if (response != null && !response.error) {
            // let file = new Blob([response], { type: "image/*" });
            // var fileURL = URL.createObjectURL(file);
            // imageBackUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
            var binary = "";
            var bytes = new Uint8Array(response);
            var len = bytes.byteLength;
            for (var i = 0; i < len; i++) {
              binary += String.fromCharCode(bytes[i]);
            }
            let url = window.btoa(binary);
            let fileURL = this.domSanitizer.bypassSecurityTrustUrl("data:image/jpg;base64," + url);

            // let imageUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
            imageBackUrl = fileURL;
            console.log(imageBackUrl);
          } else {
            progressSpinnerDialog.close();
            this.errorToast();
          }
        });
      }
      await this.auditTrailService.downloadFile(image[0].split("/").pop()).subscribe((response: any) => {
        progressSpinnerDialog.close();
        console.log(response);

        if (response != null && !response.error) {
          let file = new Blob([response], { type: "image/*" });
          var fileURL = URL.createObjectURL(file);

          setTimeout(() => {
            var binary = "";
            var bytes = new Uint8Array(response);
            var len = bytes.byteLength;
            for (var i = 0; i < len; i++) {
              binary += String.fromCharCode(bytes[i]);
            }
            let url = window.btoa(binary);
            let fileURL = this.domSanitizer.bypassSecurityTrustUrl("data:image/jpg;base64," + url);

            // let imageUrl = this.domSanitizer.bypassSecurityTrustResourceUrl(fileURL);
            let imageUrl = fileURL;
            console.log(fileURL);
            this.progressSpinnerDialog = this.dialog.open(ViewProfileDocumentComponent, {
              disableClose: false,
              width: "600px",
              data: [document.qsProfileDescription, document.qs_ans_status, imageUrl, imageBackUrl],
            });
          }, 100);
        } else {
          progressSpinnerDialog.close();
          this.errorToast();
        }
      });
    } else {
      this.warningToast();
    }
  }

  async successToast(message: any) {
    const toast = await this.toastController.create({
      message: message,
      icon: "checkmark-circle-outline",
      position: "top",
      cssClass: "toast success-toast",
      duration: 5000,
    });
    toast.present();
  }

  platform: string = "";
  async warningToast() {
    await this._snackBar.open("No data available for the entered PAN No.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "warning-toast",
      duration: 3 * 1000,
    });
  }

  async errorToast() {
    await this._snackBar.open("Oops, something went wrong, please try after sometime.", "Close", {
      horizontalPosition: "right",
      verticalPosition: "top",
      panelClass: "error-toast",
      duration: 3 * 1000,
    });
  }

  editRecord(document: any) {
    localStorage.setItem("isEdit", "true");
    localStorage.setItem("pkQsid", document.pkQsid);
    this.router.navigate(["/question-answer"]);
  }

  @ViewChild("target") MyProp: ElementRef;
  scrollIntoView() {
    this.MyProp.nativeElement.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  scrollToTopVisible = false;
  @ViewChild("divToScroll") divToScroll: ElementRef;
  onScroll(event): void {
    if (this.divToScroll.nativeElement.scrollTop > 500) {
      this.scrollToTopVisible = true;
    } else {
      this.scrollToTopVisible = false;
    }
  }

  async getSignedPdf() {
    if (this.areQuestionsNotAnswered == true) {
      this.applyNowBtnDisabled = true;
      this.downloadEsignDisabled = true;
      this.isEsignDisabled = true;
    } else {
      setTimeout(() => {
        if (this.areQuestionsNotAnswered == true) {
          this.applyNowBtnDisabled = true;
          this.downloadEsignDisabled = true;
          this.isEsignDisabled = true;
        } else {
          if (this.profileDetails[0]["affidavitStatus"] == "" && this.areQuestionsNotAnswered == false) {
            this.applyNowBtnDisabled = true;
            this.downloadEsignDisabled = true;
            this.isEsignDisabled = false;
            localStorage.removeItem("eSign");
          } else {
            this.applyNowBtnDisabled = false;
            this.downloadEsignDisabled = false;
            this.isEsignDisabled = true;
          }
        }
      }, 1000);
      return true;
    }
  }

  async casteValidityRejected(document: any) {
    // const eSignDoc = this.dialog.open(DocumentManuallyRejectedComponent, {
    //   disableClose: true,
    //   width: "600px",
    //   data: document,
    // });
    // eSignDoc.afterClosed().subscribe((result) => {
    //   if (result == "refresh") {
    //     window.location.reload();
    //   }
    // });
  }
}
